import React, { Component } from 'react'
import raf from 'raf'
import ReactHowler from 'react-howler'

import ModalDesktop from './Desktop/Portfolio/Modal'
import ModalMobile from './Mobile/Portfolio/Modal'

import firebase from '../firebase'

import './styles/PortfolioModal.css'

import samplesound from '../assets/sound/sound.ogg'

const seekTimeIncrement = 10;
const seekTimeDecrement = 10;

export default class PortfolioModal extends Component {

	state = {
		selectedSoundObject: null,
		selectedSoundtrack: samplesound,
		selectedSoundtrackName: null,
		selectedSoundtrackArtist: null,
		soundPlaying: false,
		currentTime: '00:00',
		currentEndTime: '00:00',
		barWidth: '0%',
		isSpotifyView: false,
	}

	playOrPause = () => {
		if (this.state.soundPlaying) {
			this.pauseMusic();
		} else {
			this.playMusic();
		}
	}

	pauseMusic = () => {
		this.setState({
			soundPlaying: false
		});
	}

	playMusic = () => {

		if (this.state.selectedSoundObject == null) {

			if (this.props.artist) {

				if (this.props.artist.songs.length > 0) {
					this.selectSong(this.props.artist.songs[0], this.props.artist.name);
				}

				return;	
			} else {
				return;
			}

		}

		if (this.player !== undefined && this.player !== null) {

			if (this.player.howlerState() == 'loaded') {

				let endTime = this.convertSecondsToMinutesString(this.player.duration().toFixed(2));

				this.setState({
					soundPlaying: true,
					currentEndTime: endTime
				}, () => {
					this.renderSeekTime();
				})
			}

		}

	}

	decrementSeekTime = () => {
		if (this.player !== undefined) {
			let currentSeekTime = this.player.seek();

			let decreasedTime = currentSeekTime - seekTimeDecrement;

			if (decreasedTime < 0) {
				decreasedTime = 0;
			}

			this.player.seek(decreasedTime);

			this.playMusic();
		}
	}

	incrementSeekTime = () => {
		if (this.player !== undefined) {
			let currentSeekTime = this.player.seek();

			let increasedTime = currentSeekTime + seekTimeIncrement;

			if (increasedTime > this.player.duration()) {
				increasedTime = this.player.duration();
			}

			this.player.seek(increasedTime);

			this.playMusic();
		}
	}

	renderSeekTime = () => {

		if (this.player !== undefined && this.player !== null) {

			if (this.player.howlerState() == 'loaded') {

				this.setState({
					selectedSoundtrackName: this.state.selectedSoundObject.title,
				});

				let currentSeekTime = this.player.seek().toFixed(2);
				let currenTimeString = this.convertSecondsToMinutesString(currentSeekTime);

				let endTime = this.player.duration().toFixed(2);

				let progressPercent = Math.floor((currentSeekTime / endTime) * 100);

				this.setState({
					currentTime: currenTimeString,
					barWidth: progressPercent + '%'
				})

				if (this.state.soundPlaying) {
					this._raf = raf(this.renderSeekTime)
				}

			}

		}

	}

	selectSong = (song, artistName) => {

		this.setState({
			selectedSoundObject: song,
			selectedSoundtrack: song.song,
			selectedSoundtrackName: 0,
			selectedSoundtrackArtist: artistName
		});
	}

	toggleSpotifyView = () => {
		this.setState({
			isSpotifyView: !this.state.isSpotifyView
		});

		if (this.state.soundPlaying) {
			this.pauseMusic();
		}
	}

	closeModal = () => {

		this.setState({
			soundPlaying: false,
			selectedSoundObject: null,
			selectedSoundtrack: samplesound,
			selectedSoundtrackName: null,
			selectedSoundtrackArtist: null,
			currentTime: '00:00',
			currentEndTime: '00:00',
			barWidth: '0%'
		})

		this.props.closeAction();
	}

	convertSecondsToMinutesString(time) {
		let minutesData = time / 60;
		let minutes = Math.floor(minutesData);

		let secondsData = time % 60;
		let seconds = Math.floor(secondsData);

		let minuteString = minutes.toString();

		if (minuteString.length == 1) {
			minuteString = '0' + minuteString;
		}

		let secondsString = seconds.toString();

		if (secondsString.length == 1) {
			secondsString = '0' + secondsString;
		}

		return minuteString + ':' + secondsString;
	}

  render() {

      let modalHidden = true;

      if (this.props.artist != null) {
          modalHidden = false;
      } else {
          modalHidden = true;
      }

			let currentScreen = null;
			if (this.props.isMobile) {
				currentScreen =<ModalMobile modalHidden={modalHidden}
					closeAction={this.closeModal}
					artist={this.props.artist}
					selectSongAction={this.selectSong}
					playAction={this.playOrPause}
					backwardAction={this.decrementSeekTime}
					forwardAction={this.incrementSeekTime}
					toggleSpotifyAction={this.toggleSpotifyView}
					isMusicPlaying={this.state.soundPlaying}
					barWidth={this.state.barWidth}
					songName={this.state.selectedSoundtrackName}
					songArtist={this.state.selectedSoundtrackArtist}
					isSpotifyView={this.state.isSpotifyView} />;
			} else {
				currentScreen = <ModalDesktop modalHidden={modalHidden}
					closeAction={this.closeModal}
					artist={this.props.artist} 
					selectSongAction={this.selectSong}
					playAction={this.playOrPause}
					backwardAction={this.decrementSeekTime}
					forwardAction={this.incrementSeekTime}
					toggleSpotifyAction={this.toggleSpotifyView}
					currentSeekTime={this.state.currentTime}
					endSeekTime={this.state.currentEndTime}
					isMusicPlaying={this.state.soundPlaying}
					barWidth={this.state.barWidth}
					songName={this.state.selectedSoundtrackName}
					songArtist={this.state.selectedSoundtrackArtist}
					isSpotifyView={this.state.isSpotifyView} />;
			}

			/*let howler = null;

			if (this.state.selectedSoundtrack != null) {
				
			}*/

			return (
				<div className = 'modal-container'>
					<ReactHowler
						src={this.state.selectedSoundtrack}
						playing={this.state.soundPlaying}
						ref={(ref) => (this.player = ref)}
						onLoad={this.playMusic}
					/>
					{currentScreen}
				</div>
			);
  }
}
